import type { LockContext } from '@easterngraphics/wcf/modules/utils/async';

import { Lock } from '@easterngraphics/wcf/modules/utils/async';

export function wrapWithLock<Args extends Array<unknown>, ReturnValue>(
    callback: (...args: Args) => Promise<ReturnValue>,
    lock: Lock = new Lock()
): (...args: Args) => Promise<ReturnValue> {
    return async (...args: Args): Promise<ReturnValue> => {
        const context: LockContext = await lock.acquireLock();
        try {
            return await callback(...args);
        } finally {
            context.unlock();
        }
    };
}